import { useCallback, useState } from 'react';
import GridPrintDialog from './GridPrintDialog';
import { useGridExportRegistryOptional } from 'components/grid/excel';
import { showAlert } from 'utils/toastBridge';

/**
 * 조회/리포트 화면 툴바용 출력(문서 설정) 액션
 */
export function useGridPrintAction({
  fileName = '목록출력',
  prefsUserId = '',
  defaultTitle = '',
} = {}) {
  const [open, setOpen] = useState(false);
  const registry = useGridExportRegistryOptional();

  const openDialog = useCallback(() => {
    if (!registry) {
      showAlert('목록 출력을 사용할 수 없습니다. (GridExportProvider 필요)', 'warning');
      return;
    }
    if (!registry.list().length) {
      showAlert('출력할 그리드가 등록되어 있지 않습니다.', 'warning');
      return;
    }
    setOpen(true);
  }, [registry]);

  const printButton = {
    id: 'print',
    label: '출력',
    icon: '🖨',
    onClick: openDialog,
    title: '출력 — 문서 설정 (미리보기 · 인쇄/PDF)',
  };

  const dialog = registry ? (
    <GridPrintDialog
      open={open}
      onClose={() => setOpen(false)}
      fileName={fileName}
      prefsUserId={prefsUserId}
      defaultTitle={defaultTitle}
    />
  ) : null;

  return { openDialog, printButton, dialog };
}
